import React from 'react'
import { Alert, Block, Dialog, Text } from '@mote/ui'
import { getUsersEmail } from '../../../../shared/Auth'

export const ImportScheduledDialog = ({ onDialogDismissal }) => {
  const userEmail = getUsersEmail()

  return (
    <Dialog isOpen onClose={onDialogDismissal} hasBackdrop={false}>
      <Dialog.Heading>Import Scheduled</Dialog.Heading>
      <Dialog.Content>
        <Block align='center' gap={16}>
          <Alert type='success' message='Your import has been scheduled' />
          <Text tag='p' fontSize={14}>
            Our helper elves will get to work on importing your CSV and email
            you at {userEmail} once the job is complete.
          </Text>
        </Block>

        <Block margin='33px 0 0 0'>
          <Text tag='p' color='#646F7B' fontSize={14}>
            You can now close this window
          </Text>
        </Block>
      </Dialog.Content>
    </Dialog>
  )
}
